import { Splide } from "@splidejs/splide";
import { Video } from "@splidejs/splide-extension-video";
import "@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css";
// new Splide(".splide").mount({ Video });

export const initSlideshows = () => {
	if (
		document.querySelector("#woocommerce-thumbnail-carousel") &&
		document.querySelector("#woocommerce-single-product-slider-carousel")
	) {
		let main = new Splide("#woocommerce-single-product-slider-carousel", {
			// type: "fade",
			arrows: true,
			cover: true,
			pagination: false,
			isNavigation: false,
			// drag: false,
			rewind: true,
			perPage: 1,
			breakpoints: {
				992: {
					arrows: false,
					// pagination: true,
				},
			},
		});

		let productThumbs = new Splide("#woocommerce-thumbnail-carousel", {
			direction: "ttb",
			rewind: true,
			arrows: true,
			pagination: false,
			isNavigation: true,
			height: 500,
			fixedHeight: "118px",
			// cover: true,
			perPage: 5,
			gap: "1em",
			// padding: "5em",
			// focus: "center",
			trimSpace: true,
			// drag: false,
			// dragMinThreshold: {
			// 	mouse: 4,
			// 	touch: 10,
			// },
			breakpoints: {
				992: {
					direction: "ltr",
					width: "400px",
					focus: "center",
					trimSpace: false,
					fixedWidth: "118px",
					// turn off height and fixedHeight
					height: null,
					fixedHeight: null,
					// width: "100%",
					perPage: 3,
				},
			},
		});

		main.sync(productThumbs);
		main.mount({ Video });
		productThumbs.mount();

		// determine whether to add a hide arrows class to the productThumbs based on whether slide length exceeds the perPage
		let thumbSlideNum = productThumbs.Components.Slides.getLength();
		let thumbPerPage = productThumbs.options.perPage;
		if (thumbSlideNum < thumbPerPage) {
			productThumbs.root.classList.add("hide-arrows");
		}

		// window resize because the slider breaks on resize
		window.addEventListener("resize", function () {
			let refreshed = false;
			if (window.innerWidth < 992 && !refreshed) {
				productThumbs.refresh();
			}
			// productThumbs.destroy(); // Destroy the current initialization
			// productThumbs = new Splide("#slider").mount(); // Reinitialize
		});
	}
};
